<template>
  <div class="chart-container">
    <bar-chart v-if="loaded" :chartdata="chartdata" :options="options" />
  </div>
</template>

<style scoped>
.chart-container {
  position: relative;
  margin: auto;
  height: 50vh;
}
</style>

<script>
import BarChart from "./BarSample.vue";

export default {
  name: "BarChartContainer",
  components: { BarChart },
  data: () => ({
    loaded: false,
    chartdata: null
  }),
  async mounted() {
    this.loaded = false
    try {
      const apiData = await fetch("https://enfeller.com/dogdata/data/breeds?condense=true");
      const jsonData = await apiData.json();
      const colors = ["#529EFF", "#FF6E5E", "#45FAFF", "#FFB52B", "#38FF96"];
      var bgColors = []
      for (var i = 0; i < jsonData.data.length; i++) {
        bgColors.push(colors[i % colors.length])
      }
      this.chartdata = {
        labels: jsonData.labels,
        datasets: [
          {
            data: jsonData.data,
            backgroundColor: bgColors
          }
        ]
      };
      this.options = {
        legend: {
          display:false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      };
      this.loaded = true;
    } catch (e) {
      console.error(e)
    }
  }
}
</script>
